"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.filter");
require("core-js/modules/es.array.slice");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evalConditions = evalConditions;
exports.getVariantHelper = getVariantHelper;
var _get = _interopRequireDefault(require("lodash/get"));
var _intersection = _interopRequireDefault(require("lodash/intersection"));
var _Compare = require("../enums/Compare");
var _FormulaVariables = require("../enums/FormulaVariables");
function getFilterValue(filterNameWithPrefix, product, filters, tableRow) {
  // eslint-disable-next-line prefer-destructuring
  var prefix = filterNameWithPrefix[0];
  var filterName = filterNameWithPrefix.slice(1);
  switch (prefix) {
    case _FormulaVariables.FormulaVariables.Filter:
      {
        return (0, _get.default)(filters || {}, filterName);
      }
    case _FormulaVariables.FormulaVariables.Property:
      {
        return (0, _get.default)(product, filterName);
      }
    case _FormulaVariables.FormulaVariables.Table:
      {
        return (0, _get.default)(tableRow, filterName);
      }
    default:
      {
        return undefined;
      }
  }
}
function evalConditions(product, filters, conditions, tableRow) {
  return conditions.every(function (condition) {
    var value = 'filter' in condition ? getFilterValue(condition.filter, product, filters, tableRow) : (0, _get.default)(product, condition.property);
    if ('compare' in condition) {
      switch (condition.compare) {
        case _Compare.Compare.MoreOrEqual:
          {
            return value >= condition.value;
          }
        case _Compare.Compare.More:
          {
            return value > condition.value;
          }
        case _Compare.Compare.LessOrEqual:
          {
            return value <= condition.value;
          }
        case _Compare.Compare.Less:
          {
            return value < condition.value;
          }
        case _Compare.Compare.Exist:
          {
            // TODO: заменить на более надежную проверку на существования поля
            return Boolean(value) || String(value) === '0';
          }
        case _Compare.Compare.Contains:
          {
            return (0, _intersection.default)(Array.isArray(value) ? value : [value], condition.value).length > 0;
          }
        default:
          {
            break;
          }
      }
    }
    return condition.value === value;
  });
}
function getVariantHelper(variants, filters, product, tableRow) {
  var variant = variants.find(function (item) {
    var conditions = item.conditions;
    if (!conditions || !conditions.length) {
      return false;
    }
    return evalConditions(product, filters, conditions, tableRow);
  });
  if (variant) {
    return variant;
  }
  return variants.find(function (item) {
    return !item.conditions;
  });
}